/* ============================================================
   Leora Studio-produktside (le26) — klient-adfærd
   Kører OVEN PÅ temaets eksisterende motorer og erstatter dem ikke:
     - Farvevalget er temaets NORMALE variant-picker (color-swatches
       type:'detail' → variant-radios-detail). Pris, lager og URL hører
       helt til theme.js.
     - Købet er temaets buy-buttons/product-form; sticky-baren er
       temaets <pd-sticky-bar> (main-product.js).
   Det nye her er printkammeret (simuleret print → 360°-fotos → 3D),
   knapteksten, sticky-bar-reveal og Samlingens forhåndsvisning.
   Se docs/LEORA_PRODUKTSIDE_2026_09.md.
   ============================================================ */
(function () {
  'use strict';

  var section = document.querySelector('.product-leora-section');
  if (!section) return;

  var mainForm = section.querySelector('form[id^="product-form-"]');
  var reduceMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  /* ── Hjælpere ── */
  function money(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      var fmt =
        (window.themeGlobalVariables &&
          window.themeGlobalVariables.settings &&
          window.themeGlobalVariables.settings.money_format) ||
        (window.cartStrings && window.cartStrings.money_format);
      if (fmt) return window.Shopify.formatMoney(cents, fmt);
    }
    return (cents / 100).toFixed(2).replace('.', ',') + ' kr';
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  var productData = null;
  function getProduct() {
    if (productData) return productData;
    var el = section.querySelector('.productJson, [data-product-json]');
    if (!el) return null;
    try {
      productData = JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
    return productData;
  }

  function currentVariant() {
    var data = getProduct();
    if (!data || !data.variants || !data.variants.length) return null;
    var input = mainForm && mainForm.querySelector('input[name="id"]');
    var id = input ? parseInt(input.value, 10) : NaN;
    for (var i = 0; i < data.variants.length; i++) {
      if (data.variants[i].id === id) return data.variants[i];
    }
    return data.variants[0];
  }

  /* Test-visning: temaets updateURL erstatter adressen med ?variant=… og
     taber ?view=leora, så en genindlæsning ville vise standard-skabelonen.
     Kører efter pickerens egen change-handler (bobler op til sektionen). */
  (function keepViewParam() {
    var view = new URLSearchParams(window.location.search).get('view');
    if (!view || !window.history || !window.history.replaceState) return;
    section.addEventListener('change', function () {
      setTimeout(function () {
        var params = new URLSearchParams(window.location.search);
        if (params.get('view') === view) return;
        params.set('view', view);
        window.history.replaceState(window.history.state, '', window.location.pathname + '?' + params.toString() + window.location.hash);
      }, 0);
    });
  })();

  /* ── 1) Printkammeret ──
     Simuleret print (clip-path afdækker billedet nedefra, styret af --le-p),
     derefter 360°-fotos med auto-skift og træk, og — kun når produktet har
     en 3D-model — en Fotos | 3D-vælger. setInterval (ikke rAF): rAF står
     stille i baggrundsfaner, og printet skal kunne blive færdigt. */
  var stageApi = null;
  (function initStage() {
    var stage = section.querySelector('[data-le-stage]');
    if (!stage) return;
    stage.setAttribute('data-le-ready', '');

    var slides = Array.prototype.slice.call(stage.querySelectorAll('[data-le-slide]'));
    var dotsWrap = stage.querySelector('[data-le-dots]');
    var dots = dotsWrap ? Array.prototype.slice.call(dotsWrap.querySelectorAll('[data-le-dot]')) : [];
    var label = stage.querySelector('[data-le-label]');
    var timeChip = stage.querySelector('[data-le-time]');
    var replayBtn = stage.querySelector('[data-le-replay-btn]');
    var toggle = stage.querySelector('[data-le-toggle]');
    var modelWrap = stage.querySelector('[data-le-model]');
    var secs = parseFloat(section.getAttribute('data-le-print-seconds')) || 5;
    var mode = section.getAttribute('data-le-replay') || 'always';
    var hours = parseInt(section.getAttribute('data-le-hours'), 10) || 0;
    var storeKey = 'le26-printed-' + section.getAttribute('data-product-id');
    var canSpin = slides.length > 1;

    var state = { p: 1, done: true, view: 'photos', ang: 0, auto: true };
    var printTimer = null;
    var spinTimer = null;
    var hydrated = false;
    var inView = true;

    function setP(p) {
      state.p = p;
      stage.style.setProperty('--le-p', p.toFixed(4));
      if (timeChip && !state.done && hours) {
        timeChip.textContent = Math.round(p * hours) + ' t af ca. ' + hours + ' t';
      }
    }

    function updateLabel() {
      if (!label) return;
      var text;
      if (!state.done) text = label.getAttribute('data-label-print');
      else if (state.view === '3d') text = label.getAttribute('data-label-3d');
      else text = label.getAttribute('data-label-photos');
      label.textContent = text || '';
      label.hidden = !text;
    }

    function hydrate() {
      if (hydrated) return;
      hydrated = true;
      slides.forEach(function (s) {
        var img = s.querySelector('img[data-le-src]');
        if (!img) return;
        img.srcset = img.getAttribute('data-le-srcset') || '';
        img.src = img.getAttribute('data-le-src');
        img.removeAttribute('data-le-src');
        img.removeAttribute('data-le-srcset');
      });
    }

    function show(i) {
      if (!slides.length) return;
      var n = slides.length;
      var cur = ((i % n) + n) % n;
      state.ang = i;
      slides.forEach(function (s, k) {
        s.classList.toggle('is-active', k === cur);
      });
      dots.forEach(function (d, k) {
        d.classList.toggle('is-active', k === cur);
      });
    }

    function stopSpin() {
      clearInterval(spinTimer);
      spinTimer = null;
    }

    function startSpin() {
      stopSpin();
      if (!canSpin || reduceMotion) return;
      spinTimer = setInterval(function () {
        if (state.auto && state.done && state.view === 'photos' && inView && !document.hidden) {
          show(state.ang + 1);
        }
      }, 2600);
    }

    function finish() {
      clearInterval(printTimer);
      printTimer = null;
      state.done = true;
      stage.classList.remove('is-printing');
      stage.classList.add('is-done');
      setP(1);
      hydrate();
      if (dotsWrap) dotsWrap.hidden = false;
      if (toggle) toggle.hidden = false;
      if (timeChip) timeChip.textContent = timeChip.getAttribute('data-done');
      updateLabel();
      if (mode === 'session') {
        try {
          window.sessionStorage.setItem(storeKey, '1');
        } catch (e) {}
      }
      startSpin();
    }

    function run() {
      clearInterval(printTimer);
      stopSpin();
      if (state.view === '3d') setView('photos');
      state.auto = true;
      show(0);
      if (reduceMotion || document.hidden || !slides.length) {
        finish();
        return;
      }
      state.done = false;
      stage.classList.add('is-printing');
      stage.classList.remove('is-done');
      if (dotsWrap) dotsWrap.hidden = true;
      if (toggle) toggle.hidden = true;
      updateLabel();
      setP(0);
      var t0 = performance.now();
      var dur = secs * 1000;
      printTimer = setInterval(function () {
        var k = Math.min(1, (performance.now() - t0) / dur);
        setP(1 - Math.pow(1 - k, 1.6));
        if (k >= 1) finish();
      }, 30);
    }

    /* 3D: model-viewer hentes først ved klik (samme version som designet),
       med Shopifys egen model-viewer som reserve, hvis CDN'et fejler. */
    var modelReady = null;
    function loadModelViewer() {
      if (modelReady) return modelReady;
      if (window.customElements && window.customElements.get('model-viewer')) {
        modelReady = Promise.resolve();
        return modelReady;
      }
      modelReady = import('https://ajax.googleapis.com/ajax/libs/model-viewer/3.5.0/model-viewer.min.js').catch(function () {
        return new Promise(function (resolve, reject) {
          if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') {
            reject(new Error('model-viewer'));
            return;
          }
          window.Shopify.loadFeatures([{ name: 'model-viewer', version: '1.12' }], function (err) {
            if (err) reject(err);
            else resolve();
          });
        });
      });
      return modelReady;
    }

    function setView(view) {
      if (!modelWrap && view === '3d') return;
      state.view = view;
      if (toggle) {
        toggle.querySelectorAll('[data-le-view]').forEach(function (b) {
          var on = b.getAttribute('data-le-view') === view;
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
      }
      if (view === '3d') {
        state.auto = false;
        var tpl = modelWrap.querySelector('template[data-le-model-tpl]');
        if (tpl && !modelWrap.querySelector('model-viewer')) {
          modelWrap.appendChild(tpl.content.cloneNode(true));
        }
        modelWrap.hidden = false;
        loadModelViewer().catch(function () {
          /* Uden viewer vises posteren/fotoene igen frem for en sort flade */
          setView('photos');
          if (toggle) toggle.hidden = true;
        });
      } else if (modelWrap) {
        modelWrap.hidden = true;
      }
      updateLabel();
    }

    if (toggle) {
      toggle.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-le-view]');
        if (btn) setView(btn.getAttribute('data-le-view'));
      });
    }

    dots.forEach(function (d) {
      d.addEventListener('click', function () {
        state.auto = false;
        show(parseInt(d.getAttribute('data-le-dot'), 10) || 0);
      });
    });

    if (replayBtn) replayBtn.addEventListener('click', run);

    /* Vandret træk = én vinkel pr. 60 px. Lodret scroll er uberørt
       (touch-action: pan-y på den færdige scene). */
    if (canSpin) {
      var drag = null;
      stage.addEventListener('pointerdown', function (e) {
        if (!state.done || state.view !== 'photos') return;
        if (e.target.closest('button, a')) return;
        drag = { x: e.clientX, ang: state.ang, id: e.pointerId };
        state.auto = false;
        stage.classList.add('is-dragging');
        try {
          stage.setPointerCapture(e.pointerId);
        } catch (err) {}
      });
      stage.addEventListener('pointermove', function (e) {
        if (!drag || e.pointerId !== drag.id) return;
        var step = Math.round((e.clientX - drag.x) / 60);
        var a = drag.ang - step;
        if (a !== state.ang) show(a);
      });
      var endDrag = function () {
        if (!drag) return;
        drag = null;
        stage.classList.remove('is-dragging');
      };
      stage.addEventListener('pointerup', endDrag);
      stage.addEventListener('pointercancel', endDrag);
      stage.addEventListener('lostpointercapture', endDrag);
    }

    /* Auto-skift kun når scenen er i syne */
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          inView = e.isIntersecting;
        });
      }).observe(stage);
    }

    /* Skjules fanen midt i printet, springes der til det færdige resultat */
    document.addEventListener('visibilitychange', function () {
      if (document.hidden && !state.done) finish();
    });

    stageApi = {
      showMedia: function (mediaId) {
        if (!mediaId) return;
        for (var i = 0; i < slides.length; i++) {
          if (String(slides[i].getAttribute('data-media-id')) === String(mediaId)) {
            if (state.view === '3d') setView('photos');
            state.auto = false;
            if (state.done) show(i);
            return;
          }
        }
      }
    };

    /* Startstillingen blev sat af det inline script i sektionen */
    if (stage.classList.contains('is-printing')) run();
    else finish();
  })();

  /* ── 2) Knapteksten: "Bestil — vi starter printet · 2.575,00 kr" ──
     buy-buttons skriver temaets egen tekst, og theme.js' renderBtnStatus
     overskriver den ved variantskift ("Forudbestil" når lageret er 0).
     Vi lægger designets tekst ovenpå og genopretter den, når temaet
     skriver igen. Udsolgt (disabled) lades helt urørt. */
  (function initCta() {
    var cta = section.getAttribute('data-le-cta');
    var added = section.getAttribute('data-le-cta-added');
    var btn = section.querySelector('.le26-buy .product_submit_button');
    if (!cta || !btn) return;
    var label = btn.querySelector('.btn-label');
    if (!label) return;
    var showingAdded = false;
    var pending = false;

    function ctaHtml() {
      var v = currentVariant();
      var html = '<span class="le26-cta__text">' + escapeHtml(cta) + '</span>';
      if (v) html += '<span class="btn-divider">·</span><span class="btn-price">' + money(v.price) + '</span>';
      return html;
    }

    /* Signaturen (ikke en innerHTML-sammenligning, som browseren kan
       serialisere anderledes og dermed sende observeren i ring) fortæller,
       om vores tekst stadig står der. */
    function render() {
      if (showingAdded) return;
      if (btn.classList.contains('loading')) return;
      var v = currentVariant();
      if (v && v.available === false) return;
      var sig = cta + '|' + (v ? v.price : '');
      if (label.querySelector('.le26-cta__text') && label.getAttribute('data-le-sig') === sig) return;
      label.innerHTML = ctaHtml();
      label.setAttribute('data-le-sig', sig);
    }

    new MutationObserver(function () {
      if (pending && !btn.classList.contains('loading') && !btn.disabled) {
        pending = false;
        var err = section.querySelector('.product-form__error-message');
        var failed = err && err.textContent.trim() !== '';
        if (added && !failed) {
          showingAdded = true;
          label.textContent = added;
          setTimeout(function () {
            showingAdded = false;
            render();
          }, 2200);
          return;
        }
      }
      render();
    }).observe(btn, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class', 'disabled'] });

    if (mainForm) {
      mainForm.addEventListener('submit', function () {
        pending = true;
      }, true);
    }

    section.addEventListener('change', function () {
      setTimeout(render, 0);
    });
    render();
  })();

  /* ── 3) Variantskift: farvenavn + printkammerets billede ── */
  function onVariantChange() {
    var v = currentVariant();
    if (!v) return;
    var nameEl = section.querySelector('[data-le-color-name]');
    if (nameEl) nameEl.textContent = String(v.title || '').replace(/ \/ /g, ' · ');
    if (stageApi && v.featured_media && v.featured_media.id) stageApi.showMedia(v.featured_media.id);
  }
  section.addEventListener('change', function () {
    setTimeout(onVariantChange, 0);
  });
  document.addEventListener('variant-change', onVariantChange);

  /* ── 4) Sticky-baren ──
     Vises når man har scrollet forbi 80 % af skærmen OG købsknappen ikke er
     i syne. To uafhængige signaler (IntersectionObserver + scroll) med vilje —
     lc26's bar hang på ét og kom aldrig frem
     (docs/LYSKAEDE_PRODUKTSIDE_2026_09_05.md). */
  (function initStickyReveal() {
    var sticky = section.querySelector('pd-sticky-bar');
    if (!sticky) return;
    var anchor = section.querySelector('[data-le-buy]');
    var current = null;

    function show(v) {
      if (v === current) return;
      current = v;
      sticky.classList.toggle('le26-sticky-visible', v);
    }

    function evaluate() {
      var vh = window.innerHeight || document.documentElement.clientHeight || 0;
      if (!vh) return;
      var past = (window.scrollY || window.pageYOffset || 0) > vh * 0.8;
      var ctaVisible = false;
      if (anchor) {
        var r = anchor.getBoundingClientRect();
        ctaVisible = r.bottom > 0 && r.top < vh;
      }
      show(past && !ctaVisible);
    }

    if (anchor && 'IntersectionObserver' in window) {
      new IntersectionObserver(evaluate, { threshold: 0 }).observe(anchor);
    }

    var last = 0;
    function onScroll() {
      var now = Date.now();
      if (now - last < 100) return;
      last = now;
      evaluate();
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    evaluate();
  })();

  /* ── 5) Samlingen: hover/fokus skifter forhåndsbilledet, klik åbner lampen ── */
  (function initForces() {
    var wrap = section.querySelector('[data-le-forces]');
    if (!wrap) return;
    var img = wrap.querySelector('.le26-forces__img');
    var rows = Array.prototype.slice.call(wrap.querySelectorAll('[data-le-force]'));
    var list = wrap.querySelector('.le26-forces__list');
    var currentRow = wrap.querySelector('[data-le-force].is-current') || rows[0];
    var token = 0;

    function activate(row) {
      if (!row) return;
      rows.forEach(function (r) {
        r.classList.toggle('is-active', r === row);
      });
      if (!img) return;
      var src = row.getAttribute('data-img');
      if (!src || img.getAttribute('src') === src) return;
      var mine = ++token;
      var pre = new Image();
      pre.sizes = img.getAttribute('sizes') || '';
      pre.srcset = row.getAttribute('data-srcset') || '';
      img.classList.add('is-swapping');
      pre.onload = pre.onerror = function () {
        if (mine !== token) return;
        img.srcset = row.getAttribute('data-srcset') || '';
        img.src = src;
        img.alt = row.getAttribute('data-alt') || '';
        img.classList.remove('is-swapping');
      };
      pre.src = src;
    }

    rows.forEach(function (r) {
      r.addEventListener('mouseenter', function () { activate(r); });
      r.addEventListener('focus', function () { activate(r); });
    });
    if (list) {
      list.addEventListener('mouseleave', function () { activate(currentRow); });
    }
  })();
})();
